import { render, staticRenderFns } from "./IncreaseRequest.vue?vue&type=template&id=148db3b0&"
import script from "./IncreaseRequest.vue?vue&type=script&lang=js&"
export * from "./IncreaseRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports